import {Injectable} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ModalGenericNoteComponent} from './modal-generic-note.component';

@Injectable()
export class ModalGenericNote {
  bsModalRef: BsModalRef;
  modalIsOpen = false;

  constructor(private modalService: BsModalService) {
    this.setModalListner();
  }

  setModalListner() {
    this.modalService.onHide.subscribe(() => {
      this.modalIsOpen = false;
    });
    this.modalService.onShow.subscribe(() => {
      this.modalIsOpen = true;
    });
  }

  isOpen() {
    return this.modalIsOpen;
  }

  open(options?: any): BsModalRef {
    this.bsModalRef = this.modalService.show(ModalGenericNoteComponent, {class: 'modal-md'});
    this.bsModalRef.content.options = options;
    this.bsModalRef.content.closeBtnName = 'Close';
    return this.bsModalRef;
  }

  openNavigate(options?: any): BsModalRef {
    this.bsModalRef = this.modalService.show(ModalGenericNoteComponent, {class: 'modal-md', ignoreBackdropClick: true});
    options.isNavigate = true;
    this.bsModalRef.content.options = options;
    this.bsModalRef.content.closeBtnName = 'Close';
    return this.bsModalRef;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-generic-note/modal-generic-note.service.ts